import ImageLayer from 'ol/layer/Image';
import ImageArcGISRest from 'ol/source/ImageArcGISRest';
import {proj3857, proj4326} from 'webmapsjs/dist/olHelpers/projections';

var url = 'https://sampleserver1.arcgisonline.com/ArcGIS/rest/services/' +
    'Specialty/ESRI_StateCityHighway_USA/MapServer';

export const TIME_PERIODS: string[] = ['amp', 'pmp', 'day'];
export const TIME_PERIODS_LABEL: string[] = ['AM Peak', 'PM Peak', 'Day'];
export const METRICS = ['Reliability (PTI)', 'Delay (VHD)'];
export const METRICS_LABELS = ['Planning Time Index', 'Vehicle Hours of Delay'];

export const QUARTER_ARR: string[] = ['Winter', 'Spring', 'Summer', 'Fall'];
export const mapServerUrl = 'https://transportal.cee.wisc.edu/applications/arcgis2/rest/services/NPMRDS/mapss/MapServer';
import $ = require("jquery");


export let legendInfo = {};


interface iParams {
    layers?: string,
    layerDefs?: string
}

export const mpaLayer = new ImageLayer({
    source: new ImageArcGISRest(
        {
            url: mapServerUrl,
            projection: proj3857,
            ratio: 1,
            params: {layers: `show:6`}
        }),
    visible: false,
    zIndex: 2
});

export const countyLayer = new ImageLayer({
    source: new ImageArcGISRest(
        {
            url: mapServerUrl,
            projection: proj3857,
            ratio: 1,
            params: {layers: `show:7`}
        }),
    visible: false,
    zIndex: 2
});


export function layerFromMetricPeriod(
    metric: string,
    period: string
) {

    if (!metric || !period) {
        return -1;
    }

    let lyr = -1;

    switch (metric) {
        case METRICS[0]:
            mpaLayer.setVisible(false);
            countyLayer.setVisible(true);

            switch (period) {
                case 'amp':
                    lyr = 0;
                    break;
                case 'pmp':
                    lyr = 1;
                    break;
                case 'day':
                    lyr = 2;
                    break;
                default:
                    console.log("period not found");
            }
            break;
        case METRICS[1]:

            mpaLayer.setVisible(true);
            countyLayer.setVisible(false);

            switch (period) {
                case 'amp':
                    lyr = 3;
                    break;
                case 'pmp':
                    lyr = 4;
                    break;
                case 'day':
                    lyr = 5;
                    break;
                default:
                    console.log("period not found");
            }
            break;
        default:
            console.log("metric not found");
    }

    return lyr;

}

export function genParams(
    metric: string,
    period: string,
    year: number,
    quarter: number): iParams {

    let lyr = layerFromMetricPeriod(metric, period);

    if (lyr === -1 || !year || !quarter) {
        return {};
    }

    return {
        layers: `show:${lyr}`,
        layerDefs: `{"${lyr}":"year=${year} AND QUARTER=${quarter}"}`
    };
}


export const segLayerSource = new ImageArcGISRest(
    {
        url: mapServerUrl,
        projection: proj3857,
        ratio: 1
    });

export const segLayer = new ImageLayer({
    source: segLayerSource,
    visible: false,
    zIndex: 3
});




